import { createElement, lazy, type ReactElement } from 'react';
import { resolveEventsRoute } from './events-route';

/**
 * #4918/#4923 — the page App.tsx renders for `/events/:slug` and `/events/:slug/feedback`.
 * Kept out of App.tsx so a unit test can check the wiring without rendering the app.
 */
export const EventDetailPage = lazy(() =>
  import('../pages/EventDetailPage').then((m) => ({ default: m.EventDetailPage }))
);
export const EventFeedbackPage = lazy(() =>
  import('../pages/EventFeedbackPage').then((m) => ({ default: m.EventFeedbackPage }))
);

export interface EventsPage {
  name: string;
  path: string;
  component: ReactElement;
  actions: never[];
}

/** The events page for this path, or null when the path is not a dynamic events route. */
export function eventsPageFor(currentPath: string): EventsPage | null {
  const route = resolveEventsRoute(currentPath);
  if (!route) return null;
  return route.kind === 'feedback'
    ? { name: 'Event Feedback', path: currentPath, component: createElement(EventFeedbackPage, { slug: route.slug }), actions: [] }
    : { name: 'Event Detail', path: currentPath, component: createElement(EventDetailPage, { slug: route.slug }), actions: [] };
}
